<div class="modal-header" data-cy="downloadDataScreen" data-testid="downloadDataScreen">
  <h3 class="modal-title">
    @if (exportFailed) {
      Data export failed
    } @else if (exportExpired) {
      Data export expired
    } @else {
      Data exported
    }
  </h3>
  <button type="button" class="btn-close" data-cy="closeBtn" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body d-flex flex-column gap-4" data-testid="export-download-message">
  @if (exportFailed) {
    @if (errorMessage) {
      {{ errorMessage }}
      @if (errorDetails.length > 0) {
        <ul class="mt-3 mb-0">
          @for (error of errorDetails; track error) {
            <li>{{ error }}</li>
          }
        </ul>
      }
    } @else {
      Data export failed due to a timeout error. The requested data size exceeds the limit for exporting.
      <br />
      <br />
      Please refine your export parameters or contact support for assistance.
    }
  } @else if (exportExpired) {
    <div class="align-self-center text-center">The links has expired - please generate a new export.</div>
  } @else if (!data?.fileUrl) {
    <div class="align-self-center text-center">
      Your data export is being processed. Please check your email for the download link. Action may take a few minutes depending on the
      size of the data. If you do not receive an email within the next 15 minutes, please contact support for assistance.
    </div>
  } @else {
    <div class="align-self-center">You can download the file at this link:</div>
    <div class="align-self-center">
      <a [href]="data?.fileUrl" target="_blank" data-cy="exportDownloadLink" data-testid="exportDownloadLink">Download</a>
    </div>
  }
</div>
